import React from 'react'

export default function OptionText(props) {

    const onClick = () => {
        if (props.option.disabled) return

        props.onClick(props.option)
    }

    const classes = Classes('option', {
        'highlighted': props.isHighlighted,
        disabled: props.option.disabled
    })

    const valueClass = Classes('label', {
        bold    : props.isSelected,
    })

    return (
        <div className={classes} onClick={onClick}>
            <div className={valueClass}>{props.option.label}</div>
        </div>
    )
}